<template>
  <v-dialog v-model="dialog" max-width="1000" persistent fullscreen>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="secondary"
        block
        rounded
        small
        min-width="180"
        :depressed="isMobile()"
        ><v-icon size="18" left>mdi-plus-circle-outline</v-icon> Detalhes</v-btn
      >
    </template>

    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          <v-btn icon @click="dialog = false"
            ><v-icon class="mr-2">mdi-arrow-left</v-icon></v-btn
          >

          Pedido nº {{ pedido.nrpedido }}</v-toolbar-title
        >
      </v-toolbar>
      <card-itens-pedido :pedido="pedido" />
    </v-card>
  </v-dialog>
</template>

<script>
import CardItensPedido from "./CardItensPedido.vue";

export default {
  components: { CardItensPedido },
  props: {
    pedido: Object,
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
  },
};
</script>

<style>
</style>